let user = document.head.querySelector('meta[name="user"]')?.content
if (user === 'null' || user === 'false' || user === null || user === '' || user === undefined) {
    user = false
} else {
    user = JSON.parse(user)
}

export {user as default}
